export const environment = {
  production: true,
  googleAnalyticsId: 'G-K4KSPT9TEW',
  baseHref: '/retail/nest/streamingdemo',
};
